import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import {useLocation,useParams, Outlet, useNavigate } from 'react-router-dom';
import { PiUsers,PiUserPlus,PiTrash, PiUserLight} from "react-icons/pi";
import AddUser from './AddUser';
import UserItems from './UserItems';
import AddUsers from './AddUsers';
import UserFilter from './UserFilter';
import client from '../client';
import { createDialog, QuestionDialog,ContentContainer } from 'coaz-ui';

const Users = () => {
    const {version,setVersion} = useContext(GlobalContext);
    const {userId} = useParams();
    const [buttons,setButtons] = useState([]);
    const [itemButtons,setItemButtons] = useState([]);
    const [loading,setLoading] = useState(true);
    const {request,getCurrent,errorMessage} = client;
    const path = useLocation().pathname;
    const versionRef = useRef(version);

    const setVersionRef = (ver) => {
        console.log(ver)
        versionRef.current = ver;
        setVersion(versionRef.current);
    }

    const navigate = useNavigate();

    const onAddUser = (e) => {
        createDialog({
            title:"Add User",
            Component:AddUser,
            version:versionRef.current,
            setVersion:setVersionRef
        })
    }

    const onAddUsers = (e) => {
        createDialog({
            title:"Add Users",
            Component:AddUsers,
            version:versionRef.current,
            setVersion:setVersionRef
        })
    }

    const onOpen = (user) => {
        if(user && user.ref) {
            navigate(`/_users/_user/${user.ref.id}`)
        }
    }

    const onDelete = (user,page,setPage) => {
        if(!user || !user.ref) return;
        createDialog({
            title:'Delete Role',
            submitText:"Yes",
            cancelText:"No",
            params:{
                submit:async (e) => {
                    try {
                        await request("DELETE", `users/${user.ref.id}`)
                        return {
                            message: 'Successful',
                            success: true
                        };
                    } catch (error) {
                        return {
                            message: errorMessage(error)
                        };
                    }
                },
                message:`Are you sure you want to delete ${user.name}?`
            },
            Component:QuestionDialog,
            version:versionRef.current,
            setVersion:setVersionRef
        })
    }

    const onFilter = (e) => {
        //Not complete
        createDialog({
            title:"User Filter",
            Component:UserFilter,
            version:versionRef.current,
            setVersion:setVersionRef
        })
    }

    const search = async (searchKey,page) => {
        let object = null;
        await request('GET','users/search',null,{
            searchKey:searchKey,
            pageNo:page.pageNo,
            pageSize:page.pageSize
        })
        .then((response) => {
            if(response) {
                object = {
                    users:response.content,
                    pageNo:response.number,
                    pageSize:response.size,
                    totalElements:response.totalElements,
                    totalPages:response.totalPages,
                    last:response.last
                }
            } 
        })
        .catch((error) => {
            console.log(error);
        })
        return object
    }

    const load = async () => {
        setLoading(true);
        let btns = [];
        let current = await getCurrent();
        let createUser = current.authorities.find((auth) => {return auth.authority === 'USER:CREATE'});
        let deleteUser = current.authorities.find((auth) => {return auth.authority === 'USER:DELETE'});
        if(createUser) {
            btns.push(
                {
                    Icon:PiUserPlus,
                    name:'Add User',
                    handler:onAddUser
                }
            )
            btns.push(
                {
                    Icon:PiUsers,
                    name:'Add Users',
                    handler:onAddUsers
                }
            )
        }
        if(deleteUser) {
            setItemButtons([
                {
                    Icon:PiTrash,
                    handler:onDelete,
                    name:'Delete'
                }
            ])
        }
        setButtons(btns);
        setLoading(false);
    }

    useEffect(() => {
        load();
    },[path])

  return (
    <>
    {userId?
        <Outlet context={{parentPath:`/users`}}/>:
        <ContentContainer buttons={buttons} Icon={PiUserLight} text='Users' background={true} loading={loading}>
            <div className='flex flex-col w-full h-auto p-4 space-y-2'>
                <UserItems 
                    onSelect={onOpen}
                    search={search}
                    buttons={itemButtons}
                    version={version}
                />
            </div>
        </ContentContainer>
    }
    </>
  )
}

export default Users